import { lazily } from "react-lazily";

import { lazyRouteLoader } from "app/utils/lazyRouteLoader";

import type { PreloadingRouteProps } from "app/utils/lazyRouteLoader";

// Routes.tsx imports this module statically, so it is part of the app shell's
// bundle: the page and its preload module may only be imported dynamically
// here, or the split that lets the loader run ahead of the page's chunk is
// lost.

const { AccountsAndGroupsRoute } = lazily(
  () => import("./AccountsAndGroupsRoot"),
);

/** The /admin/accounts index route: see AccountsAndGroupsRoot. */
export const accountsRoute: PreloadingRouteProps = {
  element: <AccountsAndGroupsRoute />,
  loader: lazyRouteLoader({
    load: () =>
      import("./accountsPreload").then((module) =>
        module.createAccountsLoader(),
      ),
    warm: () => import("./AccountsAndGroupsRoot"),
  }),
  // Both tabs load their own data and the tables refetch in place, so nothing
  // on the accounts page needs the loader to run again while it is open.
  shouldRevalidate: () => false,
};
